module.exports = __webpack_public_path__ + "static/img/background-login.45b2befb.jpg";